import React from 'react';
import get from 'lodash/get';
import Auth from '@Services/Auth';
import { LinkElement } from '@els/els-react--link-element';

import './BuildQueryHeading.scss';

const IDS_MAP = {
  0: 'substances, reactions and documents',
  7: 'substances, documents and bioactivity data',
  8: 'substances, reactions, documents and bioactivity data',
};

function BuildQueryHeading() {
  const user = Auth.getUser();

  return (
    <div className="build-query-heading">
      <h1>Explore Chemistry with Reaxys</h1>
      <h2 className="u-els-font-size-h3">
        Discover {IDS_MAP[get(user, 'details.reaxysId')]} with our powerful
        <LinkElement
          inline
          data-e2e="e2e-build-query-heading-integrated-database"
          isExternal
          className="u-els-margin-left-1o2"
          href="https://www.elsevier.support/reaxys/answer/which-databases-are-integrated-in-reaxys">
          integrated databases
        </LinkElement>
      </h2>
    </div>
  );
}

export default BuildQueryHeading;
